import { Reveal, SectionHead } from "../components/ui-bits";
import { useApp } from "../context/AppContext";

export default function FAQ() {
  const { config } = useApp();
  return (
    <section id="faq" className="light-section relative py-20 lg:py-28" data-testid="faq-section">
      <div className="container-x max-w-3xl">
        <SectionHead eyebrow="FAQ" light title={<>Questions, Answered.</>} align="center" />
        <div className="mt-12 flex flex-col gap-3">
          {config.faqs.map((f, i) => (
            <Reveal key={f.q} delay={Math.min(i * 0.04, 0.3)}>
              <details className="card-light group rounded-2xl px-6 py-1" data-testid={`faq-item-${i}`}>
                <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-4 text-[15px] font-semibold text-nighttext [&::-webkit-details-marker]:hidden">
                  {f.q}
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-black/10 text-[#5c5470] transition-all duration-300 group-open:rotate-45 group-open:border-carza/50 group-open:text-carza">
                    +
                  </span>
                </summary>
                <p className="pb-5 pr-8 text-sm leading-relaxed text-[#5c5470]">{f.a}</p>
              </details>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
